export const ROOT = `/*`;
export const NOMATCHES = `*`;
export const AUTH = `/auth`;
export const LOGOUT = `/logout`;
export const MAGIC_LINK = `/magic_link`;
export const SUBSCRIPTION_EXPIRED = `/subscription-expired`;
export const PRIVATE_ROUTES = {
  ROOT: `/`,
  ANALYTICS: `/analytics`,
  ROUTES: `/routes`,
  ROUTE_DETAILS: `/routes/:routeId`,
  ROUTE_REORDER: `/routes/:routeId/reorder`,
  CREATE_STOPS_MANUAL: `/routes/:routeId/create-stops/manual`,
  CREATE_STOPS_BULK: `/routes/:routeId/create-stops/bulk`,
  STOP_DETAILS: `/routes/:routeId/stops/:stopId`,
  EDIT_STOP: `/routes/:routeId/edit-stop`,
};
